export default __webpack_public_path__ + "static/media/planet.d224cc3a.webp";